export const FETCH_ALL_CERTIFICATES = 'FETCH_ALL_CERTIFICATES';
export const FETCH_ALL_CERTIFICATES_FULFILLED = 'FETCH_ALL_CERTIFICATES_FULFILLED';
export const FETCH_ALL_CERTIFICATES_REJECTED = 'FETCH_ALL_CERTIFICATES_REJECTED';
